function validatePhoneNumber(phoneNumber) {
    if(!phoneNumber){
        return true;
    }
    // Usunięcie znaków niebędących cyframi
    // Wyrażenie regularne do walidacji numeru telefonu
    var phoneNumberRegex = /^[0-9]{3}-[0-9]{3}-[0-9]{3}$/;

    // Sprawdzenie czy numer telefonu pasuje do wzorca
    return phoneNumberRegex.test(phoneNumber);
}

var mobilePhoneInput = document.getElementById("acf-field_612bdd25eba4f"); // pobiera element input z kodem pocztowym
var submitButton = document.getElementById("saveclient"); // pobiera przycisk do przesłania formularza
if($('#saveclient').length > 0) {
    submitButton.addEventListener("click", function (event) {
        var mobilePhone = mobilePhoneInput.value; // pobiera wartość kodu pocztowego z inputu
        if (!validatePhoneNumber(mobilePhone)) { // jeśli kod pocztowy jest niepoprawny, blokuje przesłanie formularza i wyświetla komunikat o błędzie
            event.preventDefault(); // blokuje przesłanie formularza
            setTimeout(function(){
                $('#acf-field_612bdd25eba4f').closest('.acf-input .acf-notice').remove();
                $('#acf-field_612bdd25eba4f').closest('.acf-input').prepend('<div class="acf-notice -error acf-error-message"><p>Niepoprawny numer telefonu komórkowego</p></div>');
            }, 1000)
            // alert("Niepoprawny numer komórki! Poprawny format to 111-111-111"); // wyświetla komunikat o błędzie
        }
    });
}

function validatePhoneNumber2(phoneNumber) {
    if(!phoneNumber){
        return true;
    }
    // Wyrażenie regularne do walidacji numeru telefonu
    var phoneNumberRegex = /^[0-9]{2}\/[0-9]{3}-[0-9]{2}-[0-9]{2}$/;

    // Sprawdzenie czy numer telefonu pasuje do wzorca
    return phoneNumberRegex.test(phoneNumber);
}

var landlinePhoneInput = document.getElementById("acf-field_612bdd17eba4e"); // pobiera element input z kodem pocztowym
var submitButton = document.getElementById("saveclient"); // pobiera przycisk do przesłania formularza
if($('#saveclient').length > 0) {
    submitButton.addEventListener("click", function (event) {
        var landlinePhone = landlinePhoneInput.value; // pobiera wartość kodu pocztowego z inputu
        if (!validatePhoneNumber2(landlinePhone)) { // jeśli kod pocztowy jest niepoprawny, blokuje przesłanie formularza i wyświetla komunikat o błędzie
            event.preventDefault(); // blokuje przesłanie formularza
            setTimeout(function(){
                $('#acf-field_612bdd17eba4e').closest('.acf-input .acf-notice').remove();
                $('#acf-field_612bdd17eba4e').closest('.acf-input').prepend('<div class="acf-notice -error acf-error-message"><p>Niepoprawny numer telefonu stacjonarnego</p></div>');
            }, 1000)
            // alert("Niepoprawny numer telefonu stacjonarnego! Poprawny format to 11/111-11-11"); // wyświetla komunikat o błędzie
        }
    });
}